<template>
  <div>
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert" v-html="errorStatus">
      
    </div>
    <div v-if="executionStatusLabel" class="alert alert-danger my-3" role="alert" >
      <div v-html="executionStatusLabel" />
      <div v-if="executionStatus===2" class="pt-2"><button type="button"  class="btn btn-sm btn-primary" @click="reenableAccount()" >{{$t('messages.attemptreenable')}}</button></div>
    </div>
    <div v-if="subscriptionStatusLabel" class="alert alert-danger my-3" role="alert" v-html="subscriptionStatusLabel">
      
    </div>
    <div v-if="!isContainerInited" class="d-flex align-items-center justify-content-center" style="min-height:300px">
      <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">{{$t('messages.loading')}}</span>
        </div>
        {{$t('messages.loading')}}
    </div>
    <div v-else-if="!hasSession" class="alert alert-primary my-3" role="alert">
      <i class="bi bi-lock"></i>
      <i18n-t keypath="messages.notsignedin" tag="span" for="messages.signin">
          <a href="#"  onclick="window.dialogManager?.showSignIn(); return false;">{{ $t('messages.signin') }}</a>
      </i18n-t>
    </div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">{{$t('messages.loading')}}</span>
        </div>
        {{$t('messages.loading')}}
    </div>
    <div v-else class="row">
    
      <div class="col-12 card card-body border-0 shadow-sm py-2 px-4">
        <h4 class="mt-3 mb-2">{{$t('messages.yourdetails')}}</h4>
       
        <div class="row">

          <div class="mb-3 col-12 col-md-6 col-xl-3" >
            <div class="fw-bold fs-xs"><i class="bi bi-envelope"></i> {{$t('messages.email')}}</div>
            <div>{{email}}</div>
            <div> <a :href="changepasswordLink" class="btn btn-sm text-primary ms-0 ps-0" >{{$t('messages.changepassword')}}</a></div>
            <div> <a href="#" @click="deleteAccount(false)" class="btn btn-sm text-primary ms-0 ps-0" >{{$t('messages.deleteaccount')}}</a></div>
          </div>

          <div class="mb-3 col-12 col-md-6 col-xl-3" >
            <div class="fw-bold fs-xs"><i class="bi bi-code-slash"></i> {{$t('messages.key')}}</div>
            <div class="fs-sm">{{apiKey}}</div>
            <div class="mt-n2">
              <a href="#" class="btn btn-sm text-primary ms-0 ps-0" @click="copyKey()" >{{isCopying?$t('messages.copying'):$t('messages.copy')}}</a>
              <a href="#" class="btn btn-sm text-primary ms-0 ps-0" @click="changeApiKey()" >{{$t('messages.change')}}</a>
            </div>
            <div class="mt-n2">
              <a href="#" class="btn btn-sm text-primary ms-0 ps-0" @click="changeSecret()" >{{$t('messages.createsecret')}}</a>
            </div>
            <div class="mt-n2 fs-sm">API Version: {{apiVersion}}</div>
          </div>
          




          <div v-if="!noAdminPermissions" class="mb-3 col-12 col-md-6 col-xl-3" >
            
            <div class="fw-bold fs-xs"><i class="bi bi-currency-dollar"></i> {{$t('messages.paymentmethod')}}</div>
            
            <div v-if="hasPaymentMethod" class="d-flex">
              <div class="text-truncate">{{paymentMethod}}</div>
            
            </div>
            <div v-else>
              {{$t('messages.nopaymentmethod')}}
           
            </div>
            <div class="mt-n2">
              <a href="#" class="btn btn-sm text-primary  ms-0 ps-0"  @click="updatePaymentMethod()" >{{$t('messages.change')}}</a>
           
            </div>

           
          </div>
          <div class="mb-3 col-12 col-md-6 col-xl-3">
              <div class="fw-bold fs-xs"><i class="bi bi-building"></i> {{$t('messages.accountdetails')}}</div>
              
              <div v-if="!noAdminPermissions"  class="mt-n2">
                <a href="#" class="btn btn-sm text-primary ms-0 ps-0"  @click="updateCustomerInfo()" >{{$t('messages.updatecustomerinfo')}}</a>
              </div>
              <div class="mt-n2">
                <a :href="usageLink" class="btn btn-sm text-primary ms-0 ps-0" >{{$t('messages.recentusage')}}</a>
              </div>
              <!--
              <div v-if="bulkAllowNotifications" class="mt-n2">
                <a href="#" class="btn btn-sm text-primary ms-0 ps-0"  @click="openAddressBook()"  >{{$t('messages.addressbook')}}</a>
              </div>
              -->
          </div>


        </div>
       
      </div>
      
      <PriceList :parentCustomerInfo="customerInfo" :isChild="true" :showFeatures="false" :showCurrentSubs="true" class="col-12 mt-3" />
      
    </div>
   

    <!-- STRIPE OPENING Modal -->

    <div class="modal" :class="{ 'fade': true, 'show': modals.stripePageOpen.isOpen }" 
         :style="{ display: modals.stripePageOpen.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="stripePageOpenModalLabel" 
         :aria-hidden="!modals.stripePageOpen.isOpen">
      
      <div v-if="modals.stripePageOpen.isOpen" class="modal-backdrop fade show"></div>
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex align-items-center justify-content-center">
              <div class="spinner-border" role="status"></div>
              <div class="ms-2">{{$t('messages.openingPaymentPage')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': modals.secretKey.isOpen }" 
         :style="{ display: modals.secretKey.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="secretKeyModalLabel" 
         :aria-hidden="!modals.secretKey.isOpen"
         @click.self="closeModal('secretKey')">
      
      <div v-if="modals.secretKey.isOpen" class="modal-backdrop fade show" @click="closeModal('secretKey')"></div>
      
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="secretKeyModalLabel">
              {{$t('messages.secretkeymodaltitle')}}
            </h5>
            <button type="button" class="btn-close" @click="closeModal('secretKey')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p><strong>{{$t('messages.yournewsecretkey')}}</strong></p>
            <div class="input-group mb-3">
              <input type="text" id="secretKeyValue" class="form-control" readonly v-model="localSecretKey">
              <button class="btn btn-secondary" type="button" @click="copySecretKey($event)">{{$t('messages.copy')}}</button>
            </div>
            <div class="alert alert-info" role="alert">
              {{$t('messages.copysecretkeywarning')}}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="closeModal('secretKey')">Ok</button>
          </div>
        </div>
      </div>
    </div>
    
      <!-- Modal -->
       <!--
    <div class="modal" :class="{ 'fade': true, 'show': modals.addressBook.isOpen }" 
         :style="{ display: modals.addressBook.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="addressBookModalLabel" 
         :aria-hidden="!modals.addressBook.isOpen"
         @click.self="closeModal('addressBook')">
      
      <div v-if="modals.addressBook.isOpen" class="modal-backdrop fade show" @click="closeModal('addressBook')"></div>
      
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addressBookModalLabel">
              {{$t('messages.addressbook')}}
            </h5>
            <button type="button" class="btn-close" @click="closeModal('addressBook')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <AddressBookEditor />
          </div>
          <div class="modal-footer">
            
          </div>
        </div>
      </div>
    </div>
-->

    <CommonModals />
    <div class="fs-sm text-muted">Version: {{ VcGlobal.VERSION }}</div>
  </div>
 
</template>
<script setup>
import { i18Utils } from "@/visualcrossing-core/i18utils";
</script>
<script>
import CommonModals from './CommonModals.vue'
import PriceList from './PriceList.vue';
import "/src/visualcrossing-core/vccommunicator_account";
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import {VcGlobal} from '/src/visualcrossing-core/vcglobal_conn';
import {VcClipboardUtils} from '/src/visualcrossing-core/vcclipboardutils';
import '/src/website-core/VcUtils';
import translations from '@/translations/accountsummary.js';
import changepassword from "@/translations/changepassword";
import { openBlock } from "vue";

export default {
  i18n: {
      messages: translations,
  },
  name: 'account',
  props: {
    
  },
  data() {
    return {
      // Modal state management
      modals: {
        stripePageOpen: { isOpen: false },
        secretKey: { isOpen: false },
        addressBook: { isOpen: false }
      },
      CANCELLATIONCOMMENTS:[
        "The product didn't work",
        "Missing a feature I needed",
        "Too expensive",
        "No longer need the product",
        "Wasn't what I expected",
      ],
      //selectedCheckoutPlan:null,
      isCopying:false,
      isContainerInited:false,
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      noAdminPermissions:false,
      customerInfo:null,
      isLoading:false,
      chooseplanmode:false,
      selectedPlan:null,
      //hasAgreedToToS:false,
      //hasAgreedToMeteredToS:false,
      //completedToS:false,
      //completedPaymentSource:false,
      businessInfo:false,
      //hasMountedStripe:false,
      stripePaymentElement:null,
      submitted:false,
      submittedSubscriptionOrder:false,
      coupon:null,
      couponId:null,
      couponError:null,
      requestedPlan:null,
      showChangeCC:false,
      localApikey:null,
      localSecretKey:null,
      //subscriptionToCancel:null,
      //cancellationComment:null,
      customerInfoEdit:{
        id:null,
        name:null,
        address:null,
        taxType:null,
        taxId:null,
        taxCountry:null,
      },
      addressElementComplete:false,
      //customerInfoSaveErrors:null,
      //clearPaymentSourceError:null,
      //pricingTableSession:null,
   
      //showRecurringPlans:false,
      //showSecondaryPlans:false,
      stripeLinkOpening:false,
    
    }
  },
  methods:{
    // New modal control methods
    openModal(modalName) {
      this.modals[modalName].isOpen = true;
    },

    closeModal(modalName) {
      this.modals[modalName].isOpen = false;
    },

    closeAllModals() {
      Object.keys(this.modals).forEach(key => {
        this.modals[key].isOpen = false;
      });
    },

    // Handle ESC key
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        // Find and close the first open modal
        const openModal = Object.keys(this.modals).find(key => this.modals[key].isOpen);
        if (openModal) {
          this.closeModal(openModal);
        }
      }
    },

    isUnpaid(inv) {
      if (!inv) return false;
      return !inv.isPaid && inv.status!=="void" && inv.amount!==0;
    },
    /*
    taxIdLabel(taxId) {
      if (!taxId) return "-";
      const country=taxId[0];
      const code=taxId[1] && taxId[1].substring(3).toUpperCase();
     
      return `${country} ${code}`;
    },
    */
    upperCase(value) {
      return value && value.toUpperCase();
    },
    deleteAccount(confirm) {
      var me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmDeleteTitle"), me.$t("messages.confirmDeleteDesc"))
          .then(function(id) {
             me.deleteAccount(true);
          }).catch((error) => {
            console.log("User said no to reenable accout"+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.deleteaccount() 
        .then(function (result) {
          me.submitted=false;
          vcCommunicator.signOut()
            .then(() => {
              this.sessionId = vcCommunicator.sessionId;
            })
            .catch((error) => {
              console.log("Sign out failed:", error);
              this.sessionId = null;
            });
        }).catch((error) => {
          me.submitted=false;
          me.errorStatus="Error deleting account. <br/>"+error;
        });
    },

    reenableAccount:function(confirm) {
      var me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmReenableTitle"), me.$t("messages.confirmReenableDesc"))
          .then(function(id) {
             me.reenableAccount(true);
          }).catch((error) => {
            console.log("User said no to reenable accout"+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.reenableaccount() 
        .then(function (result) {
          me.submitted=false;
          me.refreshCustomerInfo();
        }).catch((error) => {
          me.submitted=false;
          me.errorStatus="Error re-enabling account. <br/>"+error;
        });


    },

    changeSecret:function(confirm) {
      let me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmSecretChangeTitle"), me.$t("messages.confirmSecretChangeDesc"))
          .then(function(id) {
             me.changeSecret(true);
          }).catch((error) => {
            console.log("User said no to change secret "+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.changeSecret() 
        .then(function (result) {
          me.submitted=false;
          me.localSecretKey = result.newSecret;

          // Use Vue modal instead of Bootstrap
          me.openModal('secretKey');
         


        }).catch((error) => {
          me.submitted=false;
          me.errorStatus="Error changing secret. <br/>"+error;
        });
    },
    /*
    openAddressBook() {
      // Use Vue modal instead of Bootstrap
      this.openModal('addressBook');
    },
    */
    changeApiKey:function(confirm) {
      var me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmApiKeyChangeTitle"), me.$t("messages.confirmApiKeyChangeDesc"))
          .then(function(id) {
             me.changeApiKey(true);
          }).catch((error) => {
            console.log("User said no to chage key "+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.changeApiKey() 
        .then(function (result) {
          me.submitted=false;
          me.localApikey=result.newKey;
          //me.refreshCustomerInfo();
        }).catch((error) => {
          me.submitted=false;
          //me.refreshCustomerInfo();
          me.errorStatus="Error changing API key. <br/>"+error;
        });


    },
    copyKey:function() {
      let me=this;
      VcClipboardUtils.copyToClipboard(this.apiKey);
      this.isCopying=true;
      setTimeout(() => {
        me.isCopying=false;
      }, 2000);
      
    },
    
    copySecretKey:function(event) {
      let me=this;
      VcClipboardUtils.copyToClipboard(this.localSecretKey);
      VcUtils.changeButtonTextTemporarily(event.target, me.$t("messages.copying"), 2000); //change button text to "Copied!" for 2 seconds
     
    },
    updateCustomerInfo() {
      var me=this;
      me.createportalsession("customer_info_update");
    },
    refreshCustomerInfo() {
      var me=this;
      me.isLoading=true;
      me.customerInfo=null;
      if (!me.hasSession) return;
      vcCommunicator.refreshCustomerInfo()
        .then(function (result) {
          me.isLoading=false;
          me.errorStatus=null;
          me.customerInfo=result;
          me.noAdminPermissions=false;
          if (me.requestedPlan)  {
            me.showRequestPlan();
          }
          
         // if (!me.primarySubscription) {
         //   me.requestPricingTableSession();
         // }

        }).catch((error) => {
          me.isLoading=false;
          if (error && error.indexOf("administrative permissions")) {
            me.noAdminPermissions=true;
          } else {
            me.errorStatus="There was a problem loading the information. <br/>"+error;
            me.noAdminPermissions=false;
          }
        
        });
    },
    createportalsession(flowType, subscriptionId, planId, id) {
      var me=this;

      if (!flowType) {
        flowType="testconfig";
      }

      me.submitted=true;

      me.stripeLinkOpening=true;

      //me.showModal('#primaryPlanChooserModal', false);

      vcCommunicator.createportalsession(flowType, subscriptionId, planId, id)
        .then(function (result) {
          me.submitted=false;
          me.stripeLinkOpening=false;
          console.log("createPortalSession", result)
          window.location.href = result.url;
        }).catch((error) => {
          me.submitted=false;
           me.stripeLinkOpening=false;
          me.errorStatus="Error creating portal session. <br/>"+error;
        });
    },
    updatePaymentMethod() {
      var me=this;
      me.createportalsession("payment_method_update");
    },
    
  },
  computed:{
    usageLink() {
      return i18Utils.link("usage");
    },
    accountLink() {
      return i18Utils.link("account");
    },
    signupLink() {
      return i18Utils.link("sign-up");
    },
    changepasswordLink() {
      return i18Utils.link("change-password");
    },
    executionStatus() {
      let me=this;
      return (me.customerInfo && me.customerInfo.executionStatus) || 0;
    },
    executionStatusLabel() {
      let me=this;
      const status=me.customerInfo && me.customerInfo.executionStatus;
      switch (status) {
        case 1:
          return "Your account is disabled because your most recent payment failed. Please update your payment information or resubmit the failed payments.";
        case 2:
          return "Your account is disabled because of excessive error or overage queries. ";
        default:
          return null;
      }
    },
    taxIdDetails() {
      let me=this;
      if (!me.selectedTaxType) return "";
      return me.selectedTaxType[2];
    },
    taxIdExample() {
      let me=this;
      if (!me.selectedTaxType) return "";
      return me.selectedTaxType[3];
    },
    subscriptionStatusLabel() {
       let me=this;
       const subs=me.sessionId && me.customerInfo && me.customerInfo.subscriptions;
       if (!subs) return null;
       const subStatus=subs.reduce(function(a,d) {
          if (d.status && d.status!=='active' ) return d.status;
          return a;
       }, "active");

       if ("active"!==subStatus) {
        return `A subscription is not active. Please verify all subscriptions payments.`
       }
       
    },
    email() {
       return this.customerInfo && this.customerInfo.email;
    },
    apiKey() {
      return this.localApikey || (this.sessionState && this.sessionState.apiKey);
    },
    apiVersion() {
      return this.subscriptionParams?.apiVersion || "1.0";
    },
    hasPaymentMethod() {
      return this.paymentMethod && this.customerInfo.hasValidPaymentSource;
    },
    paymentMethod() {
      return this.customerInfo && this.customerInfo.defaultSource;
    },
    subscriptionParams() {
      return this.sessionState && this.sessionState.subscriptionParams;
    },
    bulkAllowNotifications() {
      return  this.subscriptionParams && this.subscriptionParams.bulkAllowNotifications===1
    },
    /*
    stripePricingTable() {
      var me=this;
      if (!me.pricingTableSession) return null;

      return  '<stripe-pricing-table pricing-table-id="prctbl_1NlBwoBr6gfOyd4M2jXeBUo" publishable-key="pk_test_coXU3CMX22yHtAjj76t882Ku" customer-session-client-secret="'+me.pricingTableSession+'"></stripe-pricing-table>';
    },
    showAddonPlans() {
      var me=this;
      return me.primarySubscription || me.secondarySubscriptions;
    },
    cannotSwitchToMetered() {
      var me=this;
      if (me.primarySubscription && !me.isSubMetered(me.primarySubscription) && me.primarySubscription.plan && me.primarySubscription.plan.interval==="year") {
        return "Annual subscriptions cannot be changed to metered billing";
      }
      return null;
    },
    cannotSwitchToMonthly() {
      var me=this;
      if (me.primarySubscription && !me.isSubMetered(me.primarySubscription) && me.primarySubscription.plan && me.primarySubscription.plan.interval==="year") {
        return "Annual subscriptions cannot be changed to monthly intervals";
      }
      return null;
    },
    domainCategory() {
      var me=this;
      if (!me.customerInfo || !me.customerInfo.domainCategory) return "Unknown";
      return me.customerInfo.domainCategory;
    },

    
    
  
    isSelectedPlanMetered() {
      return this.selectedPlan && this.selectedPlan.usageType==='metered'
    },
    hasRequiredPaymentInfo() {
       var me=this;
       return me.selectedPlan && (me.selectedPlan.price===0 || me.hasPaymentMethod);
    },
   
    accountBalance:function() {
      var me=this;
      if (!me.customerInfo || !me.customerInfo.accountBalance) return 0;
      return  (me.customerInfo.accountBalance/100);
    },


    hasOutstandingBalance:function() {
      var me=this;

      var pendingMeteredBalance=me.subscriptions.reduce(function (a, d) {
        a+=me.getSubInvoiceAmount(d);
        return a;
      }, 0);

      return (pendingMeteredBalance>0 || me.accountBalance>0 || me.unpaidInvoiceBalance>0);
    },
    unpaidInvoiceBalance() {
      let me=this;
      if (!me.invoices || !me.invoices.length) return 0;
      let unpaidBalance=me.invoices.reduce(function(a, inv) {
        if (!inv || inv.amount<=0 || inv.status!=="open") return a;
        return a+inv.amount;
      },0);
      return unpaidBalance;
    },
    hasAgreedToAllTos() {
      var me=this;
      if (!me.selectedPlan) return false;
      if (me.isSelectedPlanMetered) {
        return me.hasAgreedToToS && me.hasAgreedToMeteredToS;
      }
      return me.hasAgreedToToS;
    },
    
    
    hasSubscriptions() {
      return this.subscriptions && this.subscriptions.length;
    },
    hasLegacyPrimarySubscriptions() {
       return this.legacyPrimarySubscriptions && this.legacyPrimarySubscriptions.length;
    },
    hasScheduledSubscriptions() {
      return this.scheduledSubscriptions && this.scheduledSubscriptions.length;
    },
    hasInvoices() {
      return this.invoices && this.invoices.length;
    },
    isPrimaryDirectBilled() {
      var me=this;
      let subscription=me.primarySubscription;
      if (!subscription || !subscription.plan) return false;
      let product=me.getProductFromPlan(subscription.plan);
      if (product && product.isDirectBilled) return true;
        

    
      return false;
    },
    activeProducts() {
      let me=this;
      if (!me.customerInfo || !me.customerInfo.products) return null;

      let activeProducts=me.customerInfo.products.filter(function(d) {
        d.plans && d.plans.sort((a,b)=>a.price-b.price);
        return d.isActive;
      });

      activeProducts && activeProducts.sort((a,b)=>{
        if ((!a || !a.plans) && (!b || !b.plans)) return 0;
        if (!a || !a.plans) return -1;
        if (!b || !b.plans) return 1;
        return a.plans[0].price-b.plans[0].price;
      });


      return activeProducts.length && activeProducts;


    },
    
    primarySubscription() {
      let me=this;

      if (me.primarySubscriptions && me.primarySubscriptions.length) {
         return me.primarySubscriptions[0];
      }
      if (me.legacyPrimarySubscriptions && me.legacyPrimarySubscriptions.length) {
         return me.legacyPrimarySubscriptions[0];
      }
      return null;
    },
    
    primarySubscriptions() {
      let me=this;
      if (!me.subscriptions || !me.subscriptions.length) return null;
      let primarySubscriptions=me.subscriptions.filter(d=>  {
        if (d && d.plan) {
          let product=me.getProductFromPlan(d.plan);
          return product && product.isPrimary;
        }
        return false;
      });
      return primarySubscriptions.length && primarySubscriptions;
    },

    legacyPrimarySubscriptions() {
      let me=this;
      if (!me.subscriptions || !me.subscriptions.length) return null;
      let primarySubscriptions=me.subscriptions.filter(d=>  {
        if (d && d.plan) {
          let product=me.getProductFromPlan(d.plan);
          return product && product.id==='prod_EoSlQDjNxZJA0o';
          //return product && !product.isActive && product.isPrimary;
        }
        return false;
      });
      return primarySubscriptions.length && primarySubscriptions;
    },

    secondarySubscriptions() {
      let me=this;
      if (!me.subscriptions || !me.subscriptions.length) return null;
      if (!me.primarySubscription) return me.subscriptions;
      let secondarySubscriptions= me.subscriptions.filter(d=> {
        return (me.primarySubscriptions && me.primarySubscriptions.indexOf(d)===-1) || 
        (me.legacyPrimarySubscriptions && me.legacyPrimarySubscriptions.indexOf(d)===-1) 
          ;
      });
      return secondarySubscriptions.length && secondarySubscriptions;
    },

    activePrimarySubcriptionProducts() {
      let me=this;
      if (!me.activePrimaryProducts) return null;
      return me.activePrimaryProducts.filter(function(product) {
        let isSubscription=product.plans && product.plans.reduce((a,plan)=>{
          return a && !product.isHidden && plan.usageType!=="metered";
        }, true);

        return isSubscription;
      });

    },


    activePrimaryMeteredProducts() {
      let me=this;
      if (!me.activePrimaryProducts) return null;
      let activePrimaryMeteredProducts= me.activePrimaryProducts.filter(function(product) {
        let isMetered=product.plans && product.plans.reduce((a,plan)=>{
          return a && plan.usageType==="metered";
        }, true);

        return isMetered;
      });
      return activePrimaryMeteredProducts.length && activePrimaryMeteredProducts ;
    },

    activePrimaryProducts() {
      let me=this;
      if (!me.activeProducts) return null;
      let primaryProducts=me.activeProducts.filter(function(d) {
        return d.isPrimary;
      });
      return primaryProducts.length && primaryProducts ;
    },
    activeSecondaryProducts() {
      let me=this;
      if (!me.activeProducts) return null;
      let secondaryProducts=me.activeProducts.filter(function(d) {
        return d.isAddon;
      });
      return secondaryProducts.length && secondaryProducts ;
    },
    currentInactivePlans() {
      var me=this;
      if (!me.customerInfo || !me.customerInfo.products) return null;

      let inActivePlans=me.currentPlans.reduce((a,currentPlan)=>{
        if (!currentPlan.isActive) {
          a.push(currentPlan);
          return a;
        }

        let product=me.getProductFromPlan(currentPlan);

        if (product && !product.isActive) {
          a.push(currentPlan);

        }
       
         return a;

      }, []);
      
      return inActivePlans.length && inActivePlans;

    },

    
    invoices() {
      var me=this;
      let invoices=me.customerInfo && me.customerInfo.invoices;
      if (!invoices || !invoices.length) return null;

      return invoices.filter(function(d) {
        return d && d.amount>0;
      })
     },
    subscriptions() {
      var me=this;
      var subs=me.customerInfo && me.customerInfo.subscriptions;
      if (!subs || !subs.length) return [];
      return subs.reduce(function (a, d) {
        if (d) {
          d.plan=d.planId && me.getPlan(d.planId);
          if (d.plan) a.push(d)
        }
        return a;
      }, [])

    },

    scheduledSubscriptions() {
      var me=this;
      var subs=me.customerInfo && me.customerInfo.scheduledSubscriptions;
      if (!subs || !subs.length) return [];
      return subs.reduce(function (a, d) {
        if (d) {
          d.plan=d.planId && me.getPlan(d.planId);
          if (d.plan) a.push(d)
        }
        return a;
      }, [])

    },
    currentPlans() {

      var me=this;
      return me.subscriptions && me.subscriptions.reduce(function (a, d) {
        if (d && d.plan) a.push(d.plan);
        return a;
      }, []);

    },
  */
     hasSession() {
      return this.sessionId;
    }
  },
  watch: {

  },
  updated() {

  },
  unmounted() {
    var me=this;
   // me.unmountStripe();
  },
  mounted() {
    var me=this;
    // Add ESC key listener
    document.addEventListener('keydown', this.handleKeyDown);

    me.requestedPlan=VcUtils.qs["pln"] || null;

   


    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
   
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    me.isContainerInited=vcCommunicator.isInited || me.sessionId;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
      me.isContainerInited=true;
      me.refreshCustomerInfo();
    });
    vcCommunicator.addHandler('createsessionfailed', function (sessionId,sessionState) {
      me.sessionId=null;
      me.sessionState=null;

      me.isContainerInited=true;
     
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
       me.customerInfo=null;
    });

   // me.mountStripe();
    
    me.refreshCustomerInfo();


    let checkoutSessionId=VcUtils.qs["session_id"] || null;
    if (checkoutSessionId) {
      me.processCheckoutSession(checkoutSessionId);
    }
  },

  beforeUnmount() {
    // Clean up event listener
    document.removeEventListener('keydown', this.handleKeyDown);
  },

  components: {
    CommonModals,
    PriceList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wizardstep {
    min-height:200px;
  }

  /* Modal styles to ensure proper display without Bootstrap JS */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal.show {
  display: block !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-dialog {
  position: relative;
  z-index: 1060;
}
</style>